// extracted by mini-css-extract-plugin
module.exports = {"customBorder":"categorypreview-module--customBorder--2crIo","categoryShadow":"categorypreview-module--categoryShadow--1_j-H"};